import { useState } from "react"
import { CardCreationRequest, GeneratedCardData } from "@/types/card"
import api from "@/services/api"

export interface CardCreationState {
  hasAttemptedSubmit: boolean
  isPreviewMode: boolean
  cardData: GeneratedCardData | null
  isLoading: boolean
  error: string | null
  isCreatingCard: boolean
}

export interface CardCreationActions {
  createCard: (cardData: CardCreationRequest) => Promise<any>
  setIsPreviewMode: (value: boolean) => void
  setIsLoading: (value: boolean) => void
  setCardData: (data: GeneratedCardData) => void
  startCardCreation: () => void
  handleBack: () => void
}

export const useCardCreation = (onNavigate?: (path: string) => void) => {
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false)
  const [isPreviewMode, setIsPreviewMode] = useState(false)
  const [cardData, setCardData] = useState<GeneratedCardData | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [isCreatingCard, setIsCreatingCard] = useState(false)

  const startCardCreation = () => {
    setIsCreatingCard(true)
    onNavigate?.('/create')
  }

  const handleBack = () => {
    setIsPreviewMode(false)
    setIsCreatingCard(false)
    setHasAttemptedSubmit(false)
    onNavigate?.('/')
  }

  const createCard = async (cardData: CardCreationRequest) => {
    try {
      setIsLoading(true)
      setError(null)

      const response = await api.post('/api/v1/cards/generate', cardData)
      return response.data
    } catch (error) {
      console.error('Error creating card:', error)
      throw new Error('Failed to create card')
    } finally {
      setIsLoading(false)
    }
  }

  const state: CardCreationState = {
    hasAttemptedSubmit,
    isPreviewMode,
    cardData,
    isLoading,
    error,
    isCreatingCard
  }

  const actions: CardCreationActions = {
    createCard,
    setIsPreviewMode,
    setIsLoading,
    setCardData,
    startCardCreation,
    handleBack
  }

  return { state, actions }
} 